import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/styles/main.css";
import Layout from "layouts/Layout";
import Preload from "components/Lazy/Preload";
import { LinkEnhancer } from "@commerce-core/react-components";

ReactDOM.createRoot(document.getElementById("react-app")!).render(
  <React.StrictMode>
    <LinkEnhancer>
      <Preload />
      <Layout />
    </LinkEnhancer>
  </React.StrictMode>
);
